import dynamic from 'next/dynamic'
import { Box } from '~/design_system'
import { Datum } from './ChartTypes'

const SvgWrapper = dynamic(() => import('@nivo/core').then(m => m.SvgWrapper), { ssr: false })
const BoxLegendSvg = dynamic(() => import('@nivo/legends').then(m => m.BoxLegendSvg), { ssr: false })

type CustomChoroplethLegendProps = {
  data: Datum[]
  colors: string[]
  valueFormat: (value: number | string) => string
}

export const CustomChoroplethLegend = ({ data, colors, valueFormat }: CustomChoroplethLegendProps) => {
  const values = data.map(item => (typeof item.value === 'string' ? parseFloat(item.value) : item.value))
  const mn = Math.min(...values)
  const mx = Math.max(...values)

  const getLabelText = (index: number, legendSize: number): string => {
    if (index === 0) {
      return mn.toString()
    }
    return index === legendSize - 1 ? mx.toString() : ''
  }

  const colorValues = colors.slice(1, 8)

  return (
    <Box
      // anchor direction doesn't work with custom legends
      // as the CustomLegend SVG is unaware of the chart (sibling) area to position itself
      // TODO: use custom layers to achieve this
      // Temp Solution: use absolute positioning instead
      position="absolute"
      bottom="0"
      left="50%"
      transform="translateX(-50%)">
      <SvgWrapper margin={{ left: 30, top: 10, bottom: 0, right: 0 }} width={colorValues.length * 24 + 20} height={56}>
        <BoxLegendSvg
          data={colorValues.map((color: string, index: number) => {
            const label = getLabelText(index, colorValues.length)
            return {
              id: index,
              label: label ? valueFormat(label) : '',
              color
            }
          })}
          containerWidth={colorValues.length * 18}
          containerHeight={18}
          anchor="bottom-right"
          direction="row"
          itemWidth={18}
          itemHeight={18}
          itemsSpacing={0}
          symbolShape="square"
          symbolSize={18}
          padding={4}
          itemDirection="top-to-bottom"
        />
      </SvgWrapper>
    </Box>
  )
}
